<template>
  <div class="addAdvisory">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="addForm"
        label-position="rigth"
        label-width="100px"
        :rules="addFormRule"
        ref="addForm"
      >
        <div class="form-item-wrap">
          <el-form-item label="消息标题" prop="title">
            <el-input v-model="addForm.title" style="width: 200px"></el-input>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="副标题" prop="subTitle">
            <el-input v-model="addForm.subTitle" style="width:200px;"></el-input>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="消息分类" prop="type">
            <el-select
              v-model="addForm.type"
              placeholder="请选择"
              style="width: 200px"
            >
              <el-option
                v-for="item in $store.state.articleClassify"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="排序值" prop="sort">
            <el-input-number v-model="addForm.sort" :min="1" style="width:200px;"></el-input-number>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="发布日期" prop="sendTime">
            <el-date-picker
              v-model="addForm.sendTime"
              type="datetime"
              style="width: 200px"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="发布日期"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="文章摘要" prop="abstract">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              style="width: 800px"
              rows="5"
              v-model="addForm.abstract"
            >
            </el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="文章内容" prop="content">
            <!-- <wang-editor :value="addForm.content" @change="change" style="width:800px"></wang-editor> -->
            <tinymce
              :value="addForm.content"
              @input="change"
              :isEditorLoad="isEditorLoad"
            ></tinymce>
          </el-form-item>
        </div>
        <div class="form-item-wrap" style="margin-top: 20px">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button type="info" @click="resetForm">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
//组件
// import WangEditor from "@/components/WangEditor.vue";
import Tinymce from "@/components/Tinymce";
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "addAdvisory",
  data() {
    return {
      id: "",
      //新增表单
      addForm: {
        title: "", // 文章标题
        subTitle: "", // 副标题
        type: "34", // 类型
        sort: "", // 排序
        sendTime: "", // 发布日期
        abstract: "", // 摘要
        content: "", // 内容
      },
      addFormRule: {
        title: [mustFill],
        type: [mustFill],
        sendTime: [mustFill],
      },
      isEditorLoad: false, // 编辑器是否加载完成
    };
  },
  components: {
    Tinymce,
  },
  mounted() {
    //接收role传递参数
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      this.id = prams.id;
      this.getData();
    }
    console.log(this.$theMonthFirstOnDayday(), "222222222");
    this.addForm.sendTime = this.$theMonthFirstOnDayday();
  },
  methods: {
    /**富文本编辑内容改变回调 */
    change(val) {
      this.addForm.content = val;
    },
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    // 获取基础数据
    getData() {
      let data = {
        type: "QueryArticleMt",
        id: this.id,
      };
      let proc = ""; //存储过程名
      let type = "QueryArticleMt";
      this.$requestSys({
        method: "post",
        url:
          "article/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            let data = res.data[0];
            this.addForm.title = data.title;
            this.addForm.subTitle = data.tags;
            this.addForm.type = data.category_id;
            this.addForm.sort = data.sort_id;
            this.addForm.sendTime = data.add_time;
            this.addForm.abstract = data.zhaiyao;
            this.addForm.content = decodeURIComponent(atob(data.content));
            this.isEditorLoad = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let type = "SaveAdArticle";
          if (this.id) {
            type = "SaveUpArticle";
          }
          let data = {
            type: type,
            title: this.addForm.title,
            tags: this.addForm.subTitle,
            newsType: this.addForm.type,
            sortId: this.addForm.sort,
            dates: this.addForm.sendTime,
            zhaiYao: this.addForm.abstract,
            content: btoa(encodeURIComponent(this.addForm.content)),
            id: this.id,
          };
          this.$request({
            method: "post",
            url: "Article/SaveArticle",
            data: data,
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.goBack();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**重置表单 */
    resetForm() {
      this.$refs["addForm"].resetFields();
    },
  },
};
</script>

<style scoped>
.addAdvisory {
  width: 100%;
  height: 100%;
}
</style>
